"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTouchEvent = exports.default = void 0;
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var preventDefault = function preventDefault(e) {
  if (!isTouchEvent(e)) {
    return;
  }
  if (e.touches.length < 2 && e.preventDefault) {
    e.preventDefault();
  }
};

/**
 * Checks if a given event is a touch event.
 * @param {Event} e
 */
var isTouchEvent = exports.isTouchEvent = function isTouchEvent(e) {
  return e && "touches" in e;
};

/**
 * event handlers interface.
 */

/**
 * configuration options interface.
 */

/**
 * Provides a simple abstraction for working with click/touch and longPress events.
 * @param {IPressHandlers} handlers
 * @param {IOptions} options
 */
var useLongPress = function useLongPress(_ref) {
  var onLongPress = _ref.onLongPress,
    onClick = _ref.onClick;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$delay = _ref2.delay,
    delay = _ref2$delay === void 0 ? 300 : _ref2$delay,
    _ref2$shouldPreventDe = _ref2.shouldPreventDefault,
    shouldPreventDefault = _ref2$shouldPreventDe === void 0 ? true : _ref2$shouldPreventDe;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    longPressTriggered = _useState2[0],
    setLongPressTriggered = _useState2[1];
  // eslint-disable-next-line no-undef
  var timeout = (0, _react.useRef)();
  var target = (0, _react.useRef)();
  var start = (0, _react.useCallback)(function (e) {
    var unknownEvent = e;
    if (!isTouchEvent(unknownEvent)) {
      var mouseEvent = unknownEvent;
      if (mouseEvent.button !== 0) {
        // ignore if not left click... this should probably be configured in IOptions
        return;
      }
    }
    e.persist();
    var clonedEvent = _objectSpread({}, e);
    if (shouldPreventDefault && e.target) {
      e.target.addEventListener("touchend", preventDefault, {
        passive: false
      });
      target.current = e.target;
    }
    timeout.current = setTimeout(function () {
      onLongPress(clonedEvent);
      setLongPressTriggered(true);
    }, delay);
  }, [onLongPress, delay, shouldPreventDefault]);
  var clear = (0, _react.useCallback)(function (e) {
    var shouldTriggerClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    timeout.current && clearTimeout(timeout.current);
    if (shouldTriggerClick && !longPressTriggered && onClick) {
      onClick(e);
    }
    setLongPressTriggered(false);
    if (shouldPreventDefault && target.current) {
      target.current.removeEventListener("touchend", preventDefault);
    }
  }, [shouldPreventDefault, onClick, longPressTriggered]);
  return {
    onMouseDown: function onMouseDown(e) {
      return start(e);
    },
    onTouchStart: function onTouchStart(e) {
      return start(e);
    },
    onMouseUp: function onMouseUp(e) {
      return clear(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      return clear(e, false);
    },
    onTouchEnd: function onTouchEnd(e) {
      return clear(e);
    }
  };
};
var _default = exports.default = useLongPress;